import { difference } from "lodash-es";
import React from "react";
import { useLatest } from "react-use";
import { useLocalStorageAsRef } from "../hooks/useLocalStorage.js";
export function useDataGridGroupExpandedStore(apiRef, name, options) {
    const [expandedState, setExpandedState] = useLocalStorageAsRef(`msys-expanded-group-store-${name}`, {});
    const latestOptions = useLatest(options);
    const onStateChange = React.useCallback((state) => {
        const newExpandedKeys = Object.entries(state.rows.tree).flatMap(([key, row]) => row.type === "group" &&
            row.isAutoGenerated &&
            row.childrenExpanded &&
            row.groupingKey
            ? [row.groupingKey]
            : []);
        if (latestOptions.current?.keepNonExistingKeys) {
            const previouslyExpandedKeys = Object.entries(expandedState.current)
                .filter(([k, v]) => v)
                .map(([k, v]) => k);
            const currentKeys = (apiRef.current?.getAllRowIds?.() ?? []).flatMap(id => {
                const row = apiRef.current?.getRowNode?.(id);
                return row &&
                    row.type === "group" &&
                    row.isAutoGenerated &&
                    row.groupingKey
                    ? [row.groupingKey]
                    : [];
            });
            const nonExistingExpandedKeys = difference(previouslyExpandedKeys, currentKeys);
            if (nonExistingExpandedKeys.length > 0) {
                newExpandedKeys.push(...nonExistingExpandedKeys);
            }
        }
        setExpandedState(Object.fromEntries(newExpandedKeys.map(k => [k, true])));
    }, [apiRef, expandedState, latestOptions, setExpandedState]);
    const isGroupExpandedByDefault = React.useCallback((node) => Boolean(node.groupingKey &&
        typeof node.groupingKey === "string" &&
        expandedState.current[node.groupingKey]), [expandedState]);
    return { isGroupExpandedByDefault, onStateChange };
}
//# sourceMappingURL=useDataGridGroupExpandedStore.js.map